// @ts-check

import { api } from '@/api'
import * as _ from 'lodash-es'

export function getIncomes(params, page) {
  const requestBody = { params: { ...params } }

  if (page) {
    requestBody.params = Object.assign(requestBody.params, { page })
  }

  if (_.has(requestBody.params, 'search')) {
    requestBody.params.search = encodeURI(requestBody.params.search)
  }

  return api.get(`incomes`, requestBody)
}

/**
 * Creates a new income.
 * @param {*} incomePayload
 * @returns {Promise<IncomeResource>}
 */
export const createIncome = async (incomePayload) => {
  const res = await api.post('incomes', incomePayload)
  return res.data
}

/**
 * Updates an existing income.
 * @param {IncomeResource['id']} incomeId
 * @param {*} incomePayload
 * @returns {Promise<IncomeResource>}
 */
export const updateIncome = async (incomeId, incomePayload) => {
  const res = await api.put(`incomes/${incomeId}`, incomePayload)
  return res.data
}

/**
 * Returns income with the given id.
 * @param {IncomeResource['id']} incomeId
 * @returns {Promise<IncomeResource>}
 */
export const getIncomeById = async (incomeId) => {
  const res = await api.get(`incomes/${incomeId}`)
  return res.data
}

/**
 * @param {{ limit?: number }} params
 * @returns {Promise<EntryResource[]>}
 */
export const getLinkableIncomes = async (params = {}) => {
  const res = await api.get(`incomes/linkable`, {
    params
  })
  return res.data
}

export const linkBankTransactionsToIncome = async (
  bankTransactions,
  incomeId
) =>
  api.put(`incomes/link`, {
    bank_transactions: bankTransactions,
    entry_id: incomeId
  })

/**
 * Returns activity log for the income with the given id.
 * @param {IncomeResource['id']} incomeId
 * @returns {Promise<EntryLogResource[]>}
 */
export const getIncomeActivityLog = async (incomeId) => {
  const { data: activityLog } = await api.get(`log/incomes/${incomeId}/history`)
  return activityLog
}

/**
 * @param {ExpenseResource['id']} incomeId
 * @param {LedgerAccountQueryParams} params
 * @returns {Promise<LedgerAccountResource[]>}
 */
export const getIncomeLedgerAccounts = async (incomeId, params = {}) => {
  const res = await api.get(`incomes/${incomeId}/ledger-accounts`, {
    params
  })
  return res.data
}

export const makePaymentReduction = (paymentReduction) =>
  api.post(`payment-reductions`, paymentReduction)

/**
 * @param {EntryResource['id']} incomeId
 * @returns {Promise<EntryResource>}
 */
export const copyIncome = async (incomeId) => {
  const res = await api.post(`incomes/${incomeId}/copy`)
  return res.data
}

/**
 * @param {EntryResource['id']} incomeId
 */
export const deleteIncome = async (incomeId) =>
  api.delete(`incomes/${incomeId}`)

/**
 * @param {EntryQuestionTreeParams} [params={}]
 * @return {Promise<EntryQuestionTree>}
 */
export const getIncomeQuestionTree = async (params = {}) => {
  const { data: questionTree } = await api.get('incomes/question-tree', {
    params
  })
  return questionTree
}
